import { render, staticRenderFns } from "./clasificaction.vue?vue&type=template&id=19917167&scoped=true"
import script from "./clasificaction.vue?vue&type=script&lang=js"
export * from "./clasificaction.vue?vue&type=script&lang=js"
import style0 from "./clasificaction.vue?vue&type=style&index=0&id=19917167&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19917167",
  null
  
)

export default component.exports